import React from "react";
import { getProperDate } from "../../util";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import { CommissionHeaders } from "../../common/components/SectionHeader";
import "../../components/Purchases/Disclosure.css";

const DisclosureModal = props => {

	return (
	<React.Fragment>
		<div className="m-t-20">
		{props.type !== "DisclosureReadonly" ? (
			<React.Fragment>
			<CommissionHeaders>
				License Risk Report
			</CommissionHeaders>
			<HeaderDivider />
			<div className="fullwidth" id={"commission-report-basic-data"}>
				<div className="name-width">
				<div className={"commission-input-label"}>
					Company Name
				</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={props.createFormState.company_name}
					readOnly
				/>
				</div>
				<div className="ticker-width">
				<div className={"commission-input-label"}>Ticker</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={props.createFormState.ticker}
					placeholder="Ticker"
					readOnly
				/>
				</div>
				<div className="ticker-width">
				<div className={"commission-input-label"}>Risk Assessment Date</div>
				<input
					tabIndex="-1"
					className={"commission-input fullwidth"}
					value={getProperDate(
					props.createFormState.risk_assessment_date
					)}
					readOnly
				/>
				</div>
			</div>
			</React.Fragment>
		) : null}
		<div id={"corrective-events-holder"}>
			<div className="m-t-20">
			<div className={"commission-input-label"}>Notes</div>
			<textarea
				tabIndex="-1"
				readOnly
				className={"commission-input"}
				value={props.createFormState && props.createFormState.notes?props.createFormState.notes:""}
				cols={30}
				rows={2}
				placeholder={"Notes"}
			/>
			</div>
		</div>
		</div>
	</React.Fragment>
	);
};

export default DisclosureModal;



// WEBPACK FOOTER //
// ./src/dandos/components/DisclosureModal.js